import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import ErrorDisplay from "@/components/errors/ErrorDisplay";
import { IApiError } from "@/lib/types";

// ---------------------- Component

const ErrorBoundary = () => {
  // --------- Variables / Hooks

  const error = useRouteError() as IApiError;

  useEffect(() => {
    document.getElementById("app-loading-overlay")?.remove();
  }, []);

  // --------- JSX

  return <ErrorDisplay error={error} />;
};

export default ErrorBoundary;
